"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DatePicker_1 = __importDefault(require("../../../components/ApptTime/FilterToolbar/DatePicker"));
const intl_1 = require("@kyruus/intl");
const styles_1 = require("../../../components/ApptTime/FilterToolbar/styles");
const react_intl_1 = require("react-intl");
const FilterButton_1 = __importDefault(require("../../../components/ApptTime/FilterToolbar/FilterButton"));
const WeekDayFilter_1 = __importStar(require("../../../components/ApptTime/WeekDayFilter"));
const TimeFilter_1 = __importStar(require("../../../components/ApptTime/TimeFilter"));
const messages_1 = __importDefault(require("../../lib/messages"));
const styles_2 = require("./styles");
function ManageAppointmentFilterToolbar({ selectedDate, onDateChange, onClose, onDayChange, onTimeChange, filterBy, intl, headerHeight }) {
    const { dayOfWeek, timeOfDay } = filterBy;
    const NOOP = () => {
        // no operation
    };
    const dayFilterValue = [...filterBy.dayOfWeek]
        .reduce((acc, dayIndex) => {
        acc[dayIndex] = WeekDayFilter_1.DAYS_OF_WEEK[dayIndex];
        return acc;
    }, [])
        .filter(Boolean);
    const timeFilterValue = filterBy.timeOfDay.size === 0 || filterBy.timeOfDay.has(TimeFilter_1.TIME_OF_DAY.ALL)
        ? TimeFilter_1.TIME_OF_DAY.ALL
        : [...filterBy.timeOfDay].join(', ');
    return (react_1.default.createElement(styles_2.ManageAppointmentFilterToolbarContainer, { "data-testid": "manage-appointment-filters", headerHeight: headerHeight },
        react_1.default.createElement(styles_1.FilterOptionsWrapper, null,
            react_1.default.createElement(DatePicker_1.default, { date: selectedDate, onDateChange: (date) => {
                    onDateChange(date);
                }, onClose: onClose, placeholder: intl.formatMessage(messages_1.default.manageAppointmentCalendarPlaceholder) }),
            react_1.default.createElement(styles_1.DayTimeFiltersWrapper, null,
                react_1.default.createElement(react_intl_1.FormattedMessage, Object.assign({}, messages_1.default.manageAppointmentFilterBy), (FormattedMessage) => (react_1.default.createElement(styles_1.FilterByMessage, { className: "FilterByMessage" }, FormattedMessage))),
                react_1.default.createElement(FilterButton_1.default, { dataTestId: "manage-appointment-day-of-week", popoverDirection: "left", btnAriaLabel: intl.formatMessage(messages_1.default.ariaJumpToDateFilterDayOfWeekButton), btnText: dayFilterValue.length ? (dayFilterValue.map((item) => item.slice(0, 3)).join(', ')) : (react_1.default.createElement(react_intl_1.FormattedMessage, Object.assign({}, messages_1.default.manageAppointmentFilterDayOfWeek))), onOpen: NOOP },
                    react_1.default.createElement(WeekDayFilter_1.default, { filterBy: { dayOfWeek }, onChange: onDayChange })),
                react_1.default.createElement(FilterButton_1.default, { dataTestId: "manage-appointment-time-of-day", popoverDirection: "right", btnAriaLabel: intl.formatMessage(messages_1.default.ariaJumpToDateFilterTimeOfDayButton), btnText: timeFilterValue !== TimeFilter_1.TIME_OF_DAY.ALL ? (timeFilterValue) : (react_1.default.createElement(react_intl_1.FormattedMessage, Object.assign({}, messages_1.default.manageAppointmentFilterTimeOfDay))), onOpen: NOOP },
                    react_1.default.createElement(TimeFilter_1.default, { filterBy: { timeOfDay }, onChange: onTimeChange }))))));
}
exports.default = (0, intl_1.injectIntl)(ManageAppointmentFilterToolbar);
//# sourceMappingURL=ManageAppointmentFilterToolbar.js.map